/**
 * 消息框
 * 安装:
 * Vue.component('message', message);
 * Vue.prototype.$message = message;
 */
import Vue from 'vue';
import Main from './message.vue';
const MessageConstructor = Vue.extend(Main);

let instance;
const instances = [];
let seed = 1;

const Message = function(options, callback) {
    options = options || {};
    if (typeof options === 'string') {
        options = {
            message: options
        };
    }
    const id = 'message_' + seed++;
    // eslint-disable-next-line
    options.onClose = function(vm) {
        Message.close(id);
        if (callback && typeof callback === 'function') {
            callback();
        }
    };
    instance = new MessageConstructor({
        data: options
    });
    instance.id = id;
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
    instance.vm.visible = true;
    instance.dom = instance.vm.$el;
    instance.dom.style.zIndex = 1000 + seed;
    instances.push(instance);
    return instance.vm;
};

Message.close = function(id) {
    for (let i = 0, len = instances.length; i < len; i++) {
        if (id === instances[i].id) {
            instances.splice(i, 1);
            break;
        }
    }
};

['wait'].forEach(type => {
    Message[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options
            };
        }
        options.type = type;
        return Message(options);
    };
});
export default Message;



// WEBPACK FOOTER //
// ./src/marketing_components/message/index.js